import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

interface AuthenticatedResponse {
    status: string;
    user: {
        email: string;
        displayName: string;
        roles: string[];
        photo: string;
    };
}

const URL = '/api/v2/auth/me';
export function useUserProfile() {
    return useQuery({
        queryFn: async () => {
            const {
                data: { user },
            } = await axios.get<AuthenticatedResponse>(URL);

            return user;
        },
        queryKey: [URL],
    });
}
